<template>
  <piece-card title="供奉管理">
    <TabsCard v-model="active" :list="list" size="small" :gap="15" />
    <div class="worship-list flex-box">
      <InfoCard
        v-for="(item, index) in infoList"
        :key="index"
        :title="item.title"
        :value="item.value"
        class="info-item flex-grow"
      />
    </div>
    <ScreenTable :data="data" :columns="columns" class="worship-table" />
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";
import TabsCard from "../../components/tabs-card.vue";
import InfoCard from "../../components/info-card.vue";
import ScreenTable from "../../components/screen-table.vue";

export default {
  name: "Worship",
  components: {
    PieceCard,
    TabsCard,
    InfoCard,
    ScreenTable,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {
      list: [
        { label: "华严殿", value: "hyd" },
        { label: "药师殿", value: "ysd" },
        { label: "牌位堂", value: "pwt" },
      ],
      active: "hyd",
      columns: [
        { title: "时间", prop: "create_time", align: "center", render: (value) => value?.slice(0, -3), width: 140 },
        { title: "龛位编号", prop: "num", align: "center" },
        {
          title: "供奉时间",
          prop: "date",
          align: "center",
          render: (value, item) =>
            `${new Date(item.start_time * 1000).pattern("yyyy年M月d日")}-${new Date(item.end_time * 1000).pattern("yyyy年M月d日")}`,
          width: 230,
        },
      ],
    };
  },
  computed: {
    palace() {
      const { gf = {} } = this.info || {};
      return gf[this.active] || {};
    },
    infoList() {
      const palace = this.palace;
      return [
        { title: "龛位总数", value: palace.total || 0 },
        { title: "今日供奉", value: palace.today_gf || 0 },
        { title: "累计供奉数", value: palace.all_gf_count || 0 },
        { title: "即将到期", value: palace.expire_count || 0 },
      ];
    },
    data() {
      return this.palace?.list || [];
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.info-item {
  &:not(:last-of-type) {
    margin-right: 5px;
  }
}
.worship-table {
  height: 150px;
  margin-top: 4px;
}
</style>
